import React from 'react';
import "./index.css";

const Header = () => {
    return (
        <div>
            <a className="navbar-brand" href="/">ToDo List</a>
        </div>
    )
}

export default Header
